import ButtonDefault from "~/components/common/ButtonDefault";
import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useStyles from "./styles";
import { withRouter } from "react-router";
import Utils from "~/helpers/Utils";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import _ from "lodash";

const DialogPix = ({ onClose, setPix }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const [cpf, setCPF] = useState("");
	const [errorMessage, setErrorMessage] = useState("");

	const { user } = useSelector((store) => store.auth);
	const { business } = useSelector((store) => store.business);
	const meStore = useSelector((store) => store.me);

	const currentUser = meStore?.me || user || {};
	const isOwnerUser = !_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	const handleScheduleClick = () => {
		if (cpf && Utils.validateCPF(cpf.replace(/[^0-9]/g, ""))) {
			if (isOwnerUser) {
				mixpanelTrackEvent('Adicionar_Meio_De_Pagamento', { 'Meio_De_Pagamento': 'Pix' }, currentUser, business);
			}
			if (onClose) {
				onClose();
			}
			if (setPix) {
				setPix(cpf.replace(/[^0-9]/g, ""));
			}
		} else {
			setErrorMessage(t("Invalid CPF"));
		}
	};

	const cpfMask = (value) => {
		return value
			.replace(/\D/g, "")
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d{1,2})/, "$1-$2")
			.replace(/(-\d{2})\d+?$/, "$1");
	};

	const handleChange = (e) => {
		let cpf = cpfMask(e.target.value);
		setCPF(cpf);
	};
	return (
		<div className={classes.pixContainer}>
			<div className={classes.pixHeader}>
				<span className={classes.pixTitle}>{t("Pay with Pix")}</span>
				<button className={classes.pixCloseButton} onClick={onClose}>
					&#x2715;
				</button>
			</div>

			<p className={classes.pixDescription}>
				{t("Confirm CPF for Pix")}
			</p>

			<div className={classes.pixFieldWrapper}>
				<label className={classes.pixLabel}>CPF</label>
				<TextField
					placeholder={t("Enter your CPF")}
					name="cpf"
					fullWidth
					variant="outlined"
					size="small"
					value={cpf}
					onChange={handleChange}
					onKeyPress={(event) => {
						if (event.key === "Enter") {
							handleScheduleClick();
						}
					}}
					inputProps={{ maxLength: 14 }}
					error={!!errorMessage}
					InputProps={{
						classes: {
							root: classes.pixInput,
							notchedOutline: classes.pixInputOutline,
						},
					}}
				/>
				{errorMessage && <span className={classes.pixError}>{errorMessage}</span>}
			</div>

			<ButtonDefault onClick={handleScheduleClick}>
				{t("Continue to Pix")}
			</ButtonDefault>
		</div>
	);
};

export default withRouter(DialogPix);
